import { ShippingLocation_ } from 'src/api/db/apiShippingLocations'

// Helper function to format address from database fields
export const formatAddress = (location: ShippingLocation_): string => {
  const parts: string[] = []

  if (location.street_address) {
    parts.push(location.street_address)
  }
  if (location.street_number) {
    parts.push(location.street_number)
  }
  if (location.street_address_2) {
    parts.push(location.street_address_2)
  }

  const cityParts: string[] = []
  if (location.city) {
    cityParts.push(location.city)
  }
  if (location.zip_code) {
    cityParts.push(location.zip_code)
  }

  if (cityParts.length > 0) {
    parts.push(cityParts.join(' '))
  }

  return parts.join(', ') || '-'
}

// Helper function to format region display
export const formatRegion = (
  location: ShippingLocation_,
  t: (en: string, sv?: string) => string
): string => {
  if (!location.country) return '-'

  // Map common country codes to full names
  const countryNames: Record<string, string> = {
    SE: t('Sweden', 'Sverige'),
    NO: t('Norway', 'Norge'),
    DK: t('Denmark', 'Danmark'),
    FI: t('Finland', 'Finland'),
    DE: t('Germany', 'Tyskland'),
    FR: t('France', 'Frankrike'),
    GB: t('United Kingdom', 'Storbritannien'),
    US: t('United States', 'USA'),
    CA: t('Canada', 'Kanada'),
    NL: t('Netherlands', 'Nederländerna'),
    BE: t('Belgium', 'Belgien'),
    ES: t('Spain', 'Spanien'),
    IT: t('Italy', 'Italien'),
    PL: t('Poland', 'Polen'),
    AT: t('Austria', 'Österrike'),
    CH: t('Switzerland', 'Schweiz'),
  }

  const countryName = countryNames[location.country] || location.country
  return `${countryName} (${location.country})`
}

